import echo from "@/echo/echo";
import {
  clearStoredSession,
  hasSessionToken,
  redirectToWebsiteLogin,
} from "@/utils/session";

let nombreCanalSession = null;

export function suscribirAlCanalSession() {
  if (!hasSessionToken()) return false;

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch (error) {
    console.error("No se pudo leer el usuario para suscribir el canal de sesión", error);
    return false;
  }

  if (!user?.id) return false;

  const nombreDeCanal = `users.${user.id}.session`;

  if (nombreCanalSession === nombreDeCanal) return true;

  dejarCanalDeSession();
  nombreCanalSession = nombreDeCanal;

  echo
    .private(nombreDeCanal)
    .subscribed(() => {
    })
    .error((error) => {
      console.error("Error autorizando canal privado de sesión:", error);
    })
    .listen(".SessionRevoked", () => {
      dejarCanalDeSession();
      clearStoredSession();
      redirectToWebsiteLogin();
    });

  return true;
}

export function dejarCanalDeSession() {
  if (!nombreCanalSession) return;

  echo.leave(nombreCanalSession);
  nombreCanalSession = null;
}
